import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle, Home } from 'lucide-react'; // Assuming you use lucide-react or similar icon library

export default function NotFound() {
  // Set initial state to 5 seconds for a fast, user-friendly redirect
  const [seconds, setSeconds] = useState(9); 

  useEffect(() => {
    // If the timer is already at 0, don't start the interval
    if (seconds === 0) return;

    const interval = setInterval(() => {
      setSeconds((s) => {
        if (s <= 1) {
          // Use the correct method for full redirect
          window.location.href = "https://earlyjobs.ai"; 
          return 0;
        }
        return s - 1;
      });
    }, 1000); // Decrement every 1 second

    return () => clearInterval(interval);
  }, []); // Depend on initial mount

  const redirectToHome = () => {
    // Manually navigate immediately on button click
    window.location.href = "https://earlyjobs.ai";
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100 p-4">
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5, ease: "easeOut" }}
        className="max-w-md w-full p-8 sm:p-10 bg-white border border-red-200 rounded-3xl shadow-2xl flex flex-col items-center text-center space-y-6"
      >
        {/* ICON SECTION */}
        <div className="w-16 h-16 rounded-full bg-red-100 text-red-600 flex items-center justify-center shadow-inner">
          <AlertTriangle size={36} strokeWidth={2.5} />
        </div>

        {/* TEXT SECTION */}
        <div className="space-y-3">
          <h1 className="text-3xl font-extrabold text-gray-800">
            404 - Link Not Valid
          </h1>
          <p className="text-lg text-red-600 font-medium">
            The link you tried to access is not valid for assessment.
          </p>
          <p className="text-sm text-gray-500 leading-relaxed pt-2">
            You will be automatically redirected to
            <span className="font-bold text-blue-600"> earlyjobs.ai </span>
            in <span className="text-red-600 font-extrabold text-lg">{seconds}</span> seconds.
          </p>
        </div>

        {/* ACTION BUTTON */}
        <motion.button
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={redirectToHome}
          className="mt-4 px-6 py-3 bg-blue-600 text-white font-semibold rounded-xl shadow-lg hover:bg-blue-700 transition duration-200 flex items-center gap-2"
        >
          <Home size={20} />
          Go to Homepage Now
        </motion.button>

      </motion.div>
    </div>
  );
}